module.exports = __webpack_public_path__ + "img/AG.41f9b181.png";